import Q = require("q");
import { ICacheableQuery } from "Analytics/Scripts/QueryCache/ICacheableQuery";
import { ReleaseDefinitionQueryOrder } from "ReleaseManagement/Core/Contracts";
import * as VssContext from "VSS/Context";
import { VssConnection } from "VSS/Service";
import { Release } from "Widgets/Scripts/DataServices/ConfigurationQueries/Release";


import ReleaseClient = require("ReleaseManagement/Core/RestClient");
import RMContracts = require("ReleaseManagement/Core/Contracts");



export interface IReleaseDefinitionsResult {
    definitions: Release[];
    continuationToken?: string;
}

//Added below Wrapper over the ReleaseHttpClient to support ContinuationToken calls
export class ReleaseManagementHttpClient extends ReleaseClient.ReleaseHttpClient {
    public getReleaseDefinitionsWithContinuationToken(
        project: string,
        searchText?: string,
        expand?: RMContracts.ReleaseDefinitionExpands,
        top?: number,
        continuationToken?: string,
        queryOrder?: RMContracts.ReleaseDefinitionQueryOrder,
        propertySelectors?: string,
        definitionIdFilter?: string,
        path: string = null
    ): IPromise<IReleaseDefinitionsResult> {

        var queryValues: any = {
            searchText: searchText,
            '$expand': expand,
            '$top': top,
            continuationToken: continuationToken,
            queryOrder: queryOrder,
            propertySelectors: propertySelectors,
            definitionIdFilter: definitionIdFilter,
            path: path
        };

        return this._beginRequestWithAjaxResult<RMContracts.ReleaseDefinition[]>({
            httpMethod: "GET",
            area: "Release",
            locationId: "d8f96f24-8ea7-4cb6-baab-2df8fc515665",
            resource: "definitions",
            routeTemplate: "{project}/_apis/{area}/{resource}/{definitionId}",
            responseType: RMContracts.TypeInfo.ReleaseDefinition,
            responseIsCollection: true,
            routeValues: {
                project: project,
            },
            queryParams: queryValues,
            apiVersion: this.definitionsApiVersion
        }).spread(
            (definitions: RMContracts.ReleaseDefinition[], textStatus: string, jqXhr: JQueryXHR) => {
                return {
                    definitions: definitions.map((value) => {
                        return {
                            ReleaseDefinitionId: value.id,
                            Name: value.name
                        } as Release;
                    }),
                    continuationToken: jqXhr.getResponseHeader("x-ms-continuationtoken")
                }
            });
    }
}

/** Op-store cacheable query for Release Definitions. Will be replaced by an Analytics-backed query (see ReleasesQuery.ts) in the future. */
export class ReleaseDefinitionOpStoreQuery implements ICacheableQuery<Release[]>{
    private projectId: string;

    constructor() {
        this.projectId = VssContext.getDefaultWebContext().project.id;
    }

    public getKey(): string {
        return this.getQueryName() + '.' + this.projectId;
    }

    public getQueryName(): string {
        return "ReleaseDefinitionsOpStoreQuery";
    }

    public runQuery(): IPromise<Release[]> {

        let client = VssConnection.getConnection().getHttpClient(ReleaseManagementHttpClient);

        let releases: Array<Release> = new Array<Release>();
        let getAllReleaseDefinitions = (projectId: string, continuationToken: string): IPromise<Release[]> => {
            return client
                .getReleaseDefinitionsWithContinuationToken(projectId, "", 0, undefined, continuationToken, ReleaseDefinitionQueryOrder.NameAscending)
                .then((value: IReleaseDefinitionsResult) => {
                    releases.push.apply(releases, value?.definitions);
                    if (value?.continuationToken) {
                        return getAllReleaseDefinitions(projectId, value.continuationToken);
                    } else {
                        return releases;
                    }
                }, (reason) => {
                    Q.reject(reason);
                });
        }
        return getAllReleaseDefinitions(this.projectId, "");
    }
}